import { Icon } from "@iconify/react";
import React from "react";

const DEFAULT_ADDRESS = "45 Wellness Avenue, Andheri West,\nMumbai 400058, India";
const DEFAULT_PHONE = "+91 9876543210";
const DEFAULT_EMAIL = "info@medayus.com";

export default function ContactInfoWidget({ address, phone, email }) {
  const addressLines = (address || DEFAULT_ADDRESS).split(/\r?\n/).filter(Boolean);

  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        {addressLines.map((line, i) => (
          <React.Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        {phone || DEFAULT_PHONE}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        {email || DEFAULT_EMAIL}
      </li>
    </ul>
  );
}
